module.exports = "/assets/delice-page/awarded.jpg?F+HMBJN";